module.exports = __webpack_public_path__ + "static/media/img_logo_uplus.223838f2.png";